export default __webpack_public_path__ + "static/graph-storage-b1f1cb6b4cf3950d446d59cd93124013.svg";